module.exports = __webpack_public_path__ + "assets/fonts/check-list.5ad274f8.svg";